import { TealiumConstants } from '../constants/tealium.constants';

export const ToolNameConfig = [
	{
		id: 'scenario-tester',
		toolName: TealiumConstants.TOOL_NAMES.SCENARIO_TESTER_TOOL
	},
	{
		id: '360-evaluator-tool',
		toolName: TealiumConstants.TOOL_NAMES.PORTFOLIO_ANALYSER_TOOL
	},
	{
		id: 'compare-portfolios',
		toolName: TealiumConstants.TOOL_NAMES.PEER_COMPARISON_TOOL
	},
	{
		id: 'customize-models',
		toolName: TealiumConstants.TOOL_NAMES.CUSTOMIZE_MODELS_TOOL
	},
	{
		id: 'http://localhost:4209',
		toolName: TealiumConstants.TOOL_NAMES.PORTFOLIO_ANALYSER_TOOL
	},
	{
		id: 'http://localhost:4210',
		toolName: TealiumConstants.TOOL_NAMES.SCENARIO_TESTER_TOOL
	},
	{
		id: 'tax-estimator',
		toolName: TealiumConstants.TOOL_NAMES.TAX_ESTIMATOR_TOOL
	},
	{
		id: 'http://localhost:4212',
		toolName: TealiumConstants.TOOL_NAMES.TAX_ESTIMATOR_TOOL
	},
	{
		id: 'bpas',
		toolName: TealiumConstants.TOOL_NAMES.PAC_TOOL
	},
	{
		id: 'http://localhost:4211',
		toolName: TealiumConstants.TOOL_NAMES.PAC_TOOL
	},
	{
		id: 'portfolio-centre\/.*\/dashboard',
		toolName: TealiumConstants.TOOL_NAMES.PC_DASHBOARD
	},
	{
		id: 'http://localhost:4205/dashboard',
		toolName: TealiumConstants.TOOL_NAMES.PC_DASHBOARD
	},
	{
		id: 'portfolio-centre',
		toolName: TealiumConstants.TOOL_NAMES.PC_TOOL
	},
	{
		id: 'http://localhost:4205/new-analysis',
		toolName: TealiumConstants.TOOL_NAMES.PC_TOOL
	},
	{
		id: 'cma-estimator',
		toolName: TealiumConstants.TOOL_NAMES.CMA_ESTIMATOR_TOOL
	},
	{
		id: 'http://localhost:4206',
		toolName: TealiumConstants.TOOL_NAMES.CMA_ESTIMATOR_TOOL
	},
	{
		id: 'investment-quality',
		toolName: TealiumConstants.TOOL_NAMES.IQ_TOOL
	},
	{
		id: 'http://localhost:4213',
		toolName: TealiumConstants.TOOL_NAMES.IQ_TOOL
	},
	{
		id: 'monitoring',
		toolName: TealiumConstants.TOOL_NAMES.MONITORING
	},
	{
		id: 'my-portfolios',
		toolName: TealiumConstants.TOOL_NAMES.AC_PORTFOLIO_LIBRARY
	}
];
